import axios, { AxiosRequestConfig } from "axios";

import {
  cleanUserTokensFromLocalStorage,
  getAccessToken,
  getRefreshToken,
  setUserTokensToLocalStorage
} from "./helpers/auth";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

http.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const accessToken = getAccessToken();
    if (config.headers === undefined) {
      config.headers = {};
    }
    if (accessToken) {
      config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : "";
    }
    return config;
  },
  (error) => error
);

let refreshRequest: Promise<any> | null = null;

http.interceptors.response.use(response => response, async error => {
  if (error.response?.status !== 401 || error.config?.retried) return Promise.reject(error);
  const token = getRefreshToken();
  if (!token) return Promise.reject(error);
  error.config.retried = true;
  if (!refreshRequest) {
    refreshRequest = axios.post(`${process.env.REACT_APP_API_URL}/auth/refresh`, {},
      { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        setUserTokensToLocalStorage(response.data.accessToken, response.data.refreshToken);
        return response.data;
      }).finally(() => { refreshRequest = null; });
  }
  try {
    const tokens = await refreshRequest;
    error.config.headers = { ...error.config.headers, Authorization: `Bearer ${tokens.accessToken}` };
    return http.request(error.config);
  } catch (failure) {
    cleanUserTokensFromLocalStorage();
    return Promise.reject(failure);
  }
});

export default http;
